import React from "react";
import NnPlayerPianoApp from "./NnPlayerPianoApp";
import { HashRouter, Route, Link, Redirect, Switch } from "react-router-dom";
import SongManager from "./SongManager";
class App extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <HashRouter>
        <div>
          <Route
            path="/song/:songId"
            render={props => (
              <NnPlayerPianoApp songId={props.match.params.songId} />
            )}
          />
          <Route
            exact
            path="/"
            render={() => <Redirect to="/song/twinkle" />}
          />
        </div>
      </HashRouter>
    );
  }

  componentDidMount() {
    SongManager.loadSongIndex("/songs/index.json");
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js